import { Controller } from "@hotwired/stimulus";

const STORAGE_KEY = "labelwan-theme-mode";
const LEGACY_STORAGE_KEY = "magic-agent-theme-mode";
const MODES = ["light", "dark", "system"];

export default class extends Controller {
  connect() {
    this.onThemeControlClick = this.onThemeControlClick.bind(this);
    this.onSystemThemeChanged = this.onSystemThemeChanged.bind(this);

    this.mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    this.currentMode = this.readMode();

    this.applyMode(this.currentMode);
    document.addEventListener("click", this.onThemeControlClick);
    this.mediaQuery.addEventListener("change", this.onSystemThemeChanged);
  }

  disconnect() {
    document.removeEventListener("click", this.onThemeControlClick);
    this.mediaQuery?.removeEventListener("change", this.onSystemThemeChanged);
  }

  onThemeControlClick(event) {
    const control = event.target.closest("[data-theme-control]");
    if (!control) return;

    const nextMode = control.dataset.themeControl;
    if (!MODES.includes(nextMode)) return;

    this.currentMode = nextMode;
    this.persistMode(nextMode);
    this.applyMode(nextMode);
  }

  onSystemThemeChanged() {
    if (this.currentMode === "system") {
      this.applyMode("system");
    }
  }

  applyMode(mode) {
    const root = document.documentElement;

    if (mode === "system") {
      root.removeAttribute("data-theme");
      return;
    }

    root.setAttribute("data-theme", mode);
  }

  readMode() {
    let value = null;
    try {
      value = window.localStorage.getItem(STORAGE_KEY) || window.localStorage.getItem(LEGACY_STORAGE_KEY);
    } catch (_error) {
      value = null;
    }
    return MODES.includes(value) ? value : "system";
  }

  persistMode(mode) {
    try {
      window.localStorage.setItem(STORAGE_KEY, mode);
    } catch (_error) {
      // ignore storage errors and keep current runtime mode
    }
  }
}
